import { render, staticRenderFns } from "./VueAvatar.vue?vue&type=template&id=19bf984a"
import script from "./VueAvatar.vue?vue&type=script&lang=js"
export * from "./VueAvatar.vue?vue&type=script&lang=js"
import style0 from "./VueAvatar.vue?vue&type=style&index=0&id=19bf984a&lang=css"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19bf984a')) {
      api.createRecord('19bf984a', component.options)
    } else {
      api.reload('19bf984a', component.options)
    }
    module.hot.accept("./VueAvatar.vue?vue&type=template&id=19bf984a", function () {
      api.rerender('19bf984a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue"
export default component.exports